import { configureStore } from '@reduxjs/toolkit'
import { localStorageMiddleware, reHydrateStore } from './middleware';
import formReducer from './slices/formDataSlice';


export default  configureStore({
  reducer: {
    formData: formReducer,
  },
  preloadedState: reHydrateStore(),
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(localStorageMiddleware)
})
